import { InstallReducer } from "@web-monorepo/shared/podInfra";
import { Saga } from "redux-saga";
import { takeLatest, put } from "redux-saga/effects";
import boards from "data/boards.json";
import sections from "data/sections.json";

const STATE_KEY = "board";

type Author = {
  label: string;
  name: string;
  photo: string;
};

type Idea = {
  image: string;
  imageHiRes: string;
  title: string;
  // eslint-disable-next-line camelcase
  url_slug: string;
};

type Board = {
  _id?: string;
  title: string;
  slug: string;
  image: string;
  new: boolean;
  description: string;
  author: Author;
  ideas: Idea[];
};

type Section = {
  _id: string;
  order: number;
  title: string;
  boards: string[];
};

type BoardState = {
  isLoadingSections: boolean;
  isLoadingBoards: boolean;
  errorLoadingSections: boolean;
  errorLoadingBoards: boolean;
  boards: Board[];
  sections: Section[];
};

type Action =
  | { type: typeof Types.LOAD_BOARDS.request }
  | { type: typeof Types.LOAD_SECTIONS.request }
  | { type: typeof Types.LOAD_BOARDS.fail }
  | { type: typeof Types.LOAD_SECTIONS.fail }
  | { type: typeof Types.LOAD_BOARDS.done; payload: typeof boards }
  | { type: typeof Types.LOAD_SECTIONS.done; payload: typeof sections };

export type BoardSlice = { ["board"]: BoardState };

const INITIAL: BoardState = {
  isLoadingSections: false,
  isLoadingBoards: false,
  errorLoadingSections: false,
  errorLoadingBoards: false,
  sections: [],
  boards: [],
};

//
// ACTION TYPES
//
export const Types = {
  LOAD_SECTIONS: {
    request: `LOAD_SECTIONS_REQUEST`,
    done: `LOAD_SECTIONS_DONE`,
    fail: `LOAD_SECTIONS_FAIL`,
  },
  LOAD_BOARDS: {
    request: `LOAD_BOARDS_REQUEST`,
    done: `LOAD_BOARDS_DONE`,
    fail: `LOAD_BOARDS_FAIL`,
  },
} as const;

//
// ACTION CREATORS
//
export function loadSections() {
  return {
    type: Types.LOAD_SECTIONS.request,
  };
}

export function loadBoards() {
  return {
    type: Types.LOAD_BOARDS.request,
  };
}

export function reducer(state = INITIAL, action: Action): BoardState {
  switch (action.type) {
    case Types.LOAD_SECTIONS.request: {
      return {
        ...state,
        isLoadingSections: true,
      };
    }

    case Types.LOAD_SECTIONS.done: {
      const sections = action.payload;
      return {
        ...state,
        sections,
        isLoadingSections: false,
      };
    }

    case Types.LOAD_SECTIONS.fail: {
      return {
        ...state,
        errorLoadingSections: true,
        isLoadingSections: false,
      };
    }

    case Types.LOAD_BOARDS.request: {
      return {
        ...state,
        isLoadingBoards: true,
      };
    }

    case Types.LOAD_BOARDS.done: {
      const boards = action.payload;
      return {
        ...state,
        boards,
        isLoadingBoards: false,
      };
    }

    case Types.LOAD_BOARDS.fail: {
      return {
        ...state,
        errorLoadingBoards: true,
        isLoadingBoards: false,
      };
    }

    default:
      return state;
  }
}

export const selectBoards = (state: BoardSlice) => state[STATE_KEY].boards;
export const selectIsLoadingBoards = (state: BoardSlice) => state[STATE_KEY].isLoadingBoards;
export const selectSections = (state: BoardSlice) => state[STATE_KEY].sections;

function* saga() {
  yield takeLatest(Types.LOAD_BOARDS.request, function* () {
    yield put({ type: Types.LOAD_BOARDS.done, payload: boards });
  });

  yield takeLatest(Types.LOAD_SECTIONS.request, function* () {
    yield put({ type: Types.LOAD_SECTIONS.done, payload: sections });
  });
}
export default function installer(installReducer: InstallReducer, installSaga: (saga: Saga) => void) {
  installReducer(STATE_KEY, reducer);

  installSaga(saga);
}
